import * as React from "react";
import {useDispatch, useSelector} from "react-redux";
import {Box, Paper} from "@mui/material";
import StatsTable from "../components/StatsTable";
import Typography from "@mui/material/Typography";
import {useState} from "react";
import useQuery from "../../base/utils/UseQuery";
import {compareActions} from "../models/compare-slice";
import {useNavigate} from "react-router-dom";
import StatsTablePC from "../components/dark_version/StatsTablePC";

const CompareDashboard = () => {
    const contentDivHeight = useSelector((state: any) => state.base.contentDivHeight);
    // const {type, options} = useSelector((state: any) => state.compare)
    const headerHeight = 30
    const rowPadding = 10

    const [paperHeight, setPaperHeight] = useState(0)
    React.useEffect(() => {
        const height = contentDivHeight - 2 * rowPadding - headerHeight - 5;
        setPaperHeight(height)
    }, [contentDivHeight])
    const [headerContent, setHeaderContent] = useState("COMPARISON")
    const navigate = useNavigate();
    // const [o1, setO1] = React.useState("All");
    // const [o2, setO2] = React.useState("All");
    const dispatch = useDispatch();
    const options = useQuery()
    let o1 = options.get('o1')
    let o2 = options.get('o2')
    const type = options.get('type')
    if (type && o1 && o2) {
        dispatch(compareActions.setCompareParams({
            type: type,
            options: [o1, o2]
        }))
        o1 = o1.replace("$", "/")
        o2 = o2.replace("$", "/")
    } else {
        navigate("/")
    }
    // React.useEffect(()=>{
    //     setO1(options[0].replace("$", "/"))
    //     setO2(options[1].replace("$", "/"))
    // }, [options])

    return (
        <React.Fragment>
            <div id={"div-header"} className={"row"} style={{height: headerHeight}}>
                <div className={"col-md-12"}
                     style={{display: 'flex', background: '#c81e1e', alignItems: 'center'}}>
                    <Box
                        sx={{display: 'flex', flexDirection: 'row', margin: "auto"}}>
                        <Typography sx={{color: 'white'}}
                                    align={"center"}
                                    variant="h5"
                                    component="div"
                        >
                            {headerContent} (USD in Million)
                        </Typography>
                    </Box>
                </div>
            </div>

            <div className="container-fluid" style={{backgroundColor: "transparent"}}>
                <div className="row" style={{padding: rowPadding}}>
                    <div className="col-md-12 col-lg-6">
                        <Paper elevation={6}
                               style={{
                                   padding: "15px", height: paperHeight, overflowY: "auto",
                                   overflowX: "hidden"
                               }}>
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                "marginTop": "-5px",
                                "marginBottom": "-5px"
                            }}>
                                <h4 style={{color: "darkred"}}>{type?.toUpperCase()}:{o1}</h4>
                            </div>
                            <StatsTablePC optionIndex={1} height={paperHeight}/>
                        </Paper>
                    </div>
                    <div className="col-md-12 col-lg-6">
                        <Paper elevation={6}
                               style={{
                                   padding: "15px", height: paperHeight, overflowY: "auto",
                                   overflowX: "hidden"
                               }}>
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                "marginTop": "-5px",
                                "marginBottom": "-5px"
                            }}>
                                <h4 style={{color: "darkred"}}>{type?.toUpperCase()}:{o2}</h4>
                            </div>
                            <StatsTablePC optionIndex={2} height={paperHeight}/>
                        </Paper>
                    </div>

                </div>
            </div>
        </React.Fragment>
    )

}

export default CompareDashboard;
